import {Component, OnInit, Input} from '@angular/core';
import {UserService,ScrollService} from '../../../api/';
import {User} from '../../../../models/';
import {Router, ActivatedRoute} from '@angular/router';
import * as moment from "moment/moment";
import {DatePickerOptions} from 'ng2-datepicker';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
    selector: 'demographic',
    templateUrl: './demographic.component.html',
    styleUrls: ['./demographic.component.css']
})
export class DemographicComponent implements OnInit {
    public model: User;
    private ethnicities: Array<any> = [];
    private datePickerOptions: DatePickerOptions;
    verified: boolean = false;

    dateOfBirth: any;
    minDate: any = '2017-04-01';
    maxDate: any = '2017-04-30';
    currentDate: any = '';
    currentYear: any = '';
    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;

    constructor(private scrollService:ScrollService, private userService: UserService, private router: Router, private route: ActivatedRoute) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});

        this.model = new User();
    }

    submitDemographic() {

        this.blockUI.start('Loading, please wait...');
        if(this.onlineOffline1){
            this.userService.saveDemographic(this.model).subscribe((res) => {
            this.router.navigate(['/lifestyle-profile'], {queryParams: {verified: this.verified}});
        }, (err) => {

        });
        }
        localStorage.setItem("demographic", JSON.stringify(this.model));
        setTimeout(() => {
            // this.blockUI.stop(); // Stop blocking
        }, 4000);
    }

    getUserProfileData() {
        // this.dateExpires = moment("2099-12-31");
        if(this.onlineOffline1){
        this.userService.getUserProfileData().subscribe((profileData) => {
            this.model.gender = profileData.profile.gender;
            this.model.optional_race_id = profileData.profile.optional_race_id;
            // to check if other steps are already filled
            const status = localStorage.getItem('status');
            if(status > profileData.profile.status) {
                this.model.status = status;
            } else {
                this.model.status = profileData.profile.status;
            }
            // when filling the form for first time and response is empty
            if(!profileData.profile.gender) {
                this.model.gender = 'M';
            }
            if(!profileData.profile.optional_race_id) {
                this.model.optional_race_id = '19';
            }
            localStorage.setItem('status', this.model.status);
            this.model.birthdate = (profileData.profile.birthdate == '0000-00-00 00:00:00' || profileData.profile.birthdate===null) ? moment(this.currentDate).toDate() :
                moment(profileData.profile.birthdate).toDate();
            this.model.birthdate = this.model.birthdate.toISOString().substr(0, 10);
            this.datePickerOptions = new DatePickerOptions({
                autoApply: true,
                format: 'MM/DD/YYYY',

                initialDate: (this.model.birthdate || this.model.birthdate === '0000-00-00 00:00:00') ?
                    moment().toDate() : moment(this.model.birthdate).toDate()
            });
        }, (err) => {

        });
        }
    }

    getEthnicity() {
        if(this.onlineOffline1){
        this.userService.getEthnicity().subscribe((res) => {
            this.ethnicities = res;
        }, (err) => {
        });
        }
    }

    ngOnInit() {

        this.blockUI.start('Loading, please wait...');

        setTimeout(() => {
            this.currentDate = new Date();
            this.currentYear = this.currentDate.getFullYear();
            this.currentYear = this.currentYear - 13;
            this.currentDate.setFullYear(this.currentYear);
            this.currentDate = this.currentDate.toISOString().slice(0, 10);

            var el: HTMLElement = document.getElementById("dateofbirth");
            el.setAttribute("max", this.currentDate);
            this.verified = this.route.snapshot.queryParams['verified'];
            this.getEthnicity();
            this.getUserProfileData();
            this.blockUI.stop(); // Stop blocking
        }, 4000);
        this.scrollService.enableScrollIfDisabled();

    }

}



// WEBPACK FOOTER //
// ./src/app/user/signup/demographic/demographic.component.ts